import Base from './base'
import { Account } from '../types/account'

export type CRMAccount = {
  id: string
  crm_id: string
  crm_url: string
  name: string
}

export default class Company extends Base {
  async getAccount(accountId: number) {
    try {
      return await this.api.get(`companies/${accountId}?simple=true`)
    } catch (e) {
      return null
    }
  }

  async updateAccount(accountId: number, data: Partial<Account & { deleted?: boolean }>) {
    return await this.api.put(`companies/${accountId}`, data)
  }

  async getCrmAccounts(query: string): Promise<CRMAccount[]> {
    return this.api.get('crm_accounts', { params: { query } })
  }

  async getMetrics(accountId: number) {
    return await this.api.get(`companies/${accountId}/company_metrics`)
  }
}
